import { decodeBase64, encodeBase64 } from "./base64";

/**
 * User Analytics の URL グループIDから Project ID を復元する。
 * ID 形式: URLGroup:customers/{org}/projects/{project}/user_analytics/{ua}/url_groups/{group}
 * @param urlGroupId Base64 エンコード済みの URL グループID
 * @returns Base64 エンコード済み Project ID（失敗時は null）
 */
export function toProjectIdFromUaUrlGroupId(urlGroupId: string): string | null {
  try {
    const decoded = decodeBase64(urlGroupId);
    const parts = decoded.split("/");
    const orgDb = parts[1];
    const projectDb = parts[3];
    if (!orgDb || !projectDb) return null;
    const rawProject = `Project:customers/${orgDb}/projects/${projectDb}`;
    return encodeBase64(rawProject);
  } catch {
    return null;
  }
}

/**
 * User Analytics の URL グループIDから UserAnalytics ID を復元する。
 * @param urlGroupId Base64 エンコード済みの URL グループID
 * @returns Base64 エンコード済み UserAnalytics ID（失敗時は null）
 */
export function toUserAnalyticsIdFromUaUrlGroupId(
  urlGroupId: string,
): string | null {
  try {
    const decoded = decodeBase64(urlGroupId);
    const parts = decoded.split("/");
    const orgDb = parts[1];
    const projectDb = parts[3];
    const uaDb = parts[5];
    if (!orgDb || !projectDb || !uaDb) return null;
    const rawUa = `UserAnalytics:customers/${orgDb}/projects/${projectDb}/user_analytics/${uaDb}`;
    return encodeBase64(rawUa);
  } catch {
    return null;
  }
}
